import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FichaVerificacaoSegurancaComponent } from './ficha-verificacao-seguranca.component';

const routes: Routes = [
  {
    path: '',
    component: FichaVerificacaoSegurancaComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FichaVerificacaoSegurancaRoutingModule { }
